import axios from 'axios';
import config from '../../config/configureSettings';
import { constructServiceURL } from '../../core/modules/common/tools/URLTools';

export const fetchReceptacle = (receptacleId) => axios.get(constructServiceURL({
  endpoint: 'fetchReceptacle',
  stub: config.useStubbedEndpoints,
  params: { receptacleId },
}));
